import React from "react";

export const AboutUs = () => {
    return (
        <div className="container mb-6">
            <h1 className="text-34 font-semibold">About Us</h1>
            <div className="mb-4 pb-2">
                <h2 className="text-2xl font-semibold">Powering Retail. Building Partnerships.</h2>
                <p className="line-height-3 text-color-secondary">
                    At Woodland Distributors, we believe wholesale is more than moving products—it’s about helping businesses grow.
                </p>
                <p className="line-height-3 text-color-secondary">
                    Every day, retailers rely on us to keep their shelves stocked with the products their customers want. From smoke shops and convenience
                    stores to gas stations and specialty retailers, we provide a carefully curated selection of trusted brands, innovative products, and
                    everyday essentials backed by dependable service.
                </p>
                <p className="line-height-3 text-color-secondary">
                    We’re committed to making wholesale simple. That means competitive pricing, reliable inventory, fast fulfillment, and a team that’s
                    always ready to help. Whether you’re placing your first order or managing multiple retail locations, we strive to be the distribution
                    partner you can count on.
                </p>
            </div>

            <div className="mb-4 pb-2">
                <h2 className="text-2xl font-semibold">More Than a Distributor</h2>
                <p className="line-height-3 text-color-secondary">
                    We don’t just deliver products—we build long-term relationships. By staying ahead of industry trends and continuously expanding our
                    product selection, we help our customers stay competitive in an ever-changing marketplace.
                </p>
                <p className="line-height-3 text-color-secondary">
                    Our growing catalog includes premium smoking accessories, vape hardware, lighters, torches, glass products, rolling papers, wraps,
                    grinders, and a wide range of convenience store essentials from respected brands around the world.
                </p>
            </div>

            <div className="mb-4 pb-2">
                <h2 className="text-2xl font-semibold">Why Businesses Choose Woodland Distributors</h2>
                <ul className="line-height-3 text-color-secondary pl-4">
                    <li>Reliable inventory from trusted manufacturers</li>
                    <li>Competitive wholesale pricing</li>
                    <li>Fast, efficient order fulfillment</li>
                    <li>Dedicated customer support</li>
                    <li>Constantly expanding product selection</li>
                    <li>A partnership-first approach to business</li>
                </ul>
            </div>

            <div className="mb-4 pb-2">
                <h2 className="text-2xl font-semibold">Our Promise</h2>
                <p className="line-height-3 text-color-secondary">
                    When you partner with Woodland Distributors, you’re choosing more than a supplier. You’re choosing a team that values integrity,
                    consistency, and your long-term success. We understand the challenges retailers face, and we’re committed to providing the products,
                    service, and support that help your business thrive.
                </p>
            </div>

            <div>
                <h2 className="text-2xl font-semibold">Let’s Grow Together</h2>
                <p className="line-height-3 text-color-secondary">
                    Your success drives everything we do. Whether you’re an independent retailer or a growing chain, Woodland Distributors is here to help
                    you stay stocked, stay competitive, and stay ahead.
                </p>
            </div>
        </div>
    );
};
